/**
 * Outlined Clear filter button — fixed size so it matches on Events, Promotions, Contacts, etc.
 */
export const clearFilterButtonSx = {
  textTransform: 'none',
  borderRadius: '10px',
  width: 200,
  minWidth: 200,
  maxWidth: 200,
  height: 40,
  minHeight: 40,
  maxHeight: 40,
  boxSizing: 'border-box',
  paddingLeft: '12px',
  paddingRight: '12px',
  borderWidth: 2,
  borderStyle: 'solid',
  borderColor: '#0F3D3E',
  color: '#0F3D3E',
  backgroundColor: '#fff',
  fontWeight: 500,
  fontSize: '0.875rem',
  lineHeight: 1.2,
  boxShadow: 'none',
  '&:hover': {
    borderWidth: 2,
    borderColor: '#0a2829',
    backgroundColor: '#ebf4f4',
    color: '#0a2829',
    boxShadow: 'none',
  },
  '& .MuiButton-startIcon': {
    color: 'inherit',
    marginRight: '6px',
    marginLeft: '-4px',
  },
};
